<template>
  <div
    :style="[styles.base,styles.fontStyle]"
    :class="[{'text-box--hide':isCarouselAnimation}]"
    @click="handleClickEvent()"
    @mouseenter="handleEvent('hover')"
  >
    <p
      :class="configurationData.isShowScrollBar ? 'text-content-show' : 'text-content-hide'"
      :style="animateOrScrollBar"
    >
      <template v-if="Array.isArray(text)">
        <p
          v-for="(item, index) in text"
          :key="index"
          class="text-content-item"
          style="white-space: pre-line;"
        >
          {{ item }}
        </p>
      </template>
      <template v-else>
        <p style="white-space: pre-line;">
        {{ text }}
        </p>
      </template>
    </p>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import { componentBaseMixin } from '@tencent/ceiba-base-components';
import './text.scss';
export default {
  name: 'CText',
  mixins: [componentBaseMixin],
  data() {
    return {
      randomText: '',
      eventUid: '',
    };
  },
  computed: {
    isCarouselAnimation() {
      const { animate = {} } = this.styles;
      if (animate['animation-name'] === 'carousel') return true;
      return false;
    },
    text() {
      return this.configurationData.textContent;
    },
    hideOnPlatform() {
      return this.configurationData.hideOnPlatform;
    },
    hideOnDevices() {
      return this.configurationData.hideOnDevices;
    },
    animateOrScrollBar() {
      const { backgroundColorHighlight, backgroundColorGrey } = this.configurationData;
      return Object.assign({}, this.styles.animate, {
        '--backgroundColorHighlight': backgroundColorHighlight,
        '--backgroundColorGrey': backgroundColorGrey,
        '--scrollBarWidth': this.deviceMode === 'pc' ? '5px' : '0.06rem',
      });
    },
  },
  destroyed() {
    if (this.interval) {
      clearInterval(this.interval);
    }
  },
  mounted() {
    this.getTextOptimized();
  },
  methods: {
    getTextOptimized() {
      if (this.configurationData.hideOnDevices && this.configurationData.hideOnPlatform) {
        this.configurationData.hideOnDevices.forEach((item) => {
          if (this.$platform.device === item) {
            this.configurationData.hideOnPlatform.forEach((el) => {
              if (this.$platform.platform === el) {
                this.styles.base.display = 'none';
              }
            });
          }
        });
      }
    },
    getRandomValue() {
      // 随机数据
      const { params } = this.intervalDataFetchList.deviceProperty;
      if (params.dsType === 'number') {
        const max = Math.max(...params.dsNumberRange);
        const min = Math.min(...params.dsNumberRange);
        return parseInt((Math.random() * (max - min)) + min, 10);
      }
      const max = params.dsStringRange.length;
      const index = parseInt((Math.random() * (max - 0)), 10);
      return params.dsStringRange[index] || '';
    },
    // 演示数据
    getDemonstrateText(params) {
      if (params.effect === 'random') {
        // 定时随机返回一个数据
        this.randomText = this.getRandomValue();
        return this.randomText;
      }
      return '';
    },
  },
};
</script>
<style lang="scss" scoped>
.text-box--hide {
  overflow: hidden;
}

.text-content-show,
.text-content-hide {
  height: 100%;
  overflow-y: auto;

  &-item {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
}

// 滚动条展示时样式
.text-content-show::-webkit-scrollbar-thumb {
  background: var(--backgroundColorHighlight);
}

.text-content-show::-webkit-scrollbar {
  width: var(--scrollBarWidth);
}

.text-content-show::-webkit-scrollbar-track-piece {
  background-color: var(--backgroundColorGrey);
}
// 滚动条不展示时候的样式
.text-content-hide::-webkit-scrollbar {
  width: var(--scrollBarWidth);
}

</style>
